import axios from "axios"
import { APIURL } from "src/config/helpers/base"

export const setDataSuggestionCategories = () => {
    return (dispatch) => {
        dispatch({ type: 'DATA_SUGGESTION_CATEGORIES', payload: false })
        axios.get(`${APIURL}/one/Webs/GetUserSuggestionCategories`).then(res => {
            var data = res.data;
            dispatch({ type: 'DATA_SUGGESTION_CATEGORIES', payload: data })
        })
    }
}
export const setDataDatasetCategories = () => {
    return (dispatch) => {
        dispatch({ type: 'DATA_DATASET_CATEGORIES', payload: false })
        axios.get(`${APIURL}/one/Webs/GetDatasetCategories`).then(res => {
            var data = res.data;
            dispatch({ type: 'DATA_DATASET_CATEGORIES', payload: data })
        })
    }
}

export const setFormKritikSaran = (formType, formValue) => {
    return {type: 'FORM_KRITIK_SARAN', formType, formValue}
}

export const apiSaveUserSuggestion = (iData, alert) => {
    return (dispatch) => {
        var fd = new FormData();

        if (iData.Name === "") {
            alert.info("Nama wajib diisi!")
            return;
        }
        if (iData.Email === "") {
            alert.info("Email wajib diisi!")
            return;
        }
        if (iData.Mobile === "") {
            alert.info("Nomor HP wajib diisi!")
            return;
        }
        if (iData.UserSuggestionCategoryId === "") {
            alert.info("Kategori pemohon wajib diisi!")
            return;
        }
        if (iData.DatasetCategoryId === "") {
            alert.info("Dataset yang disarankan wajib diisi!")
            return;
        }
        if (iData.DatasetSuggestion === "") {
            alert.info("Saran dataset wajib diisi!")
            return;
        }
        if (iData.DatasetReason === "") {
            alert.info("Alasan wajib diisi!")
            return;
        }

        fd.append('Name', iData.Name);
        fd.append('Email', iData.Email);
        fd.append('Mobile', iData.Mobile);
        fd.append('DatasetSuggestion', iData.DatasetSuggestion);
        fd.append('DatasetReason', iData.DatasetReason);
        fd.append('UserSuggestionCategoryId', iData.UserSuggestionCategoryId);
        fd.append('DatasetCategoryId', iData.DatasetCategoryId);

        axios.post(`${APIURL}/one/User/SaveUserSuggestion`,fd).then((res) => {
            let data = res.data;
            if (data.IsSuccess) {
                dispatch({type: 'RESET_FORM_KRITIK_SARAN'})
                alert.success('Pesan anda berhasil dikirim!', {
                    timeout: 2000,
                    onClose: () => window.location.reload()
                })
            } else {
                alert.error(data.ReturnMessage)
            }
        })
    }
}